module.exports = __webpack_public_path__ + "img/svg/background-create-match-modal.9fa17b2651629488ce8c368a1473f10a.svg";